import { render, staticRenderFns } from "./ModalSorter.vue?vue&type=template&id=0fff104c&scoped=true&"
import script from "./ModalSorter.vue?vue&type=script&lang=js&"
export * from "./ModalSorter.vue?vue&type=script&lang=js&"
import style0 from "./ModalSorter.vue?vue&type=style&index=0&id=0fff104c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fff104c",
  null
  
)

export default component.exports